<template>
  <hic-list-page title="护理项目维护" :entities="entities" :condition="condition" @load="init" keyword-placeholder="请输入名称或助记码" :loading="meta.loading">
    <template slot="buttons">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="selInfo={};meta.showDetail = true">新建</el-button>
    </template>
    <el-table-column align="center" label="操作" width="150" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button type="primary" title="编辑" size="mini" plain icon="el-icon-edit" circle @click="inDetail(row)"></el-button>
        <el-button type="danger" title="删除" size="mini" plain icon="el-icon-delete" circle @click="delNurse(row)"></el-button>
      </template>
    </el-table-column>
    <el-table-column align="left" label="名称" prop="name" min-width="100">
      <template #default="{row}">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column align="left" label="编码" prop="code" width="100"></el-table-column>
    <el-table-column align="left" label="规格" prop="standard" min-width="200" show-overflow-tooltip></el-table-column>
    <!-- <el-table-column align="center" label="助记码	" prop="shortCode"></el-table-column> -->
    <el-table-column align="center" label="分类" prop="" :filters="dict.NursingItemType" :filter-multiple="false" column-key="type" width="100">
      <template slot-scope="{ row }">
        <div>{{ row.type | dictText("NursingItemType") }}</div>
      </template>
    </el-table-column>
    <!-- <el-table-column align="center" label="费用标准" prop="standardName"></el-table-column> -->
    <el-table-column align="right" label="单价	" prop="price" width="100">
      <template #default="{row}">
        <span class="danger">{{ row.price | fmtFloat }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="单位	" prop="unit" width="60"></el-table-column>
    <el-table-column align="center" label="医保类别" prop="" :filters="dict.ReimburseCategory" :filter-multiple="false" column-key="insuranceClass" width="120">
      <template slot-scope="{ row }">
        <div>{{ row.insuranceClass | dictText("ReimburseCategory") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="工伤险类别" prop="" :filters="dict.ReimburseCategory" :filter-multiple="false" column-key="injuryClass" width="120">
      <template slot-scope="{ row }">
        <div>{{ row.injuryClass | dictText("ReimburseCategory") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="财务分类" prop="" :filters="dict.StandardFeeClass" :filter-multiple="false" column-key="feeClass" width="120">
      <template slot-scope="{ row }">
        <div>{{ row.feeClass | dictText("StandardFeeClass") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="费用标准分类" prop="" :filters="dict.StandardClass" :filter-multiple="false" column-key="standardClass" width="120">
      <template slot-scope="{ row }">
        <div>{{ row.standardClass | dictText("StandardClass") }}</div>
      </template>
    </el-table-column>
    <!-- <el-table-column align="center" label="性别" prop="" :filters="dict.Gender" :filter-multiple="false" column-key="gender">
      <template slot-scope="{ row }">
        <div>{{ row.gender | dictText("Gender") }}</div>
      </template>
    </el-table-column> -->
    <!-- <el-table-column align="center" label="最小年龄	" prop="ageMin"></el-table-column> -->
    <!-- <el-table-column align="center" label="最大年龄" prop="ageMax"></el-table-column> -->
    <!-- <el-table-column align="center" label="备注" prop="memo"></el-table-column> -->
    <new :title="dtitle" :feeStandList="feeList" :infoDetail="selInfo" :visible.sync="meta.showDetail" @close="page"></new>
    <hic-paging :entities="entities" :condition="condition" @load="init"></hic-paging>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic"
  export default {
    components: {
      new: () => import("./new"),
      // daily: () => import("./daily"),
      // operation: () => import("./operation"),
    },
    data() {
      return {
        dtitle: "护理项目新增",
        meta: {
          showOper: false,
          showDaily: false,
          showDetail: false,
          loading: false,
        },
        selInfo: {},
        condition: {
          keyword: null,
          pageSize: 20,
          pageIndexOnView: 1,
          sort: "id",
          asc: false,
        },
        entities: {},
        feeList:[]
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    methods: {
      create() {
      },
      init(){
        this.condition.pageIndexOnView = 1
        this.page()
      },
      page() {
        this.meta.loading = true;
        try {
          api.NursingItem.query(this.condition).then((res) => {
              this.entities = res;
            })
            .catch((err) => {
              this.$message.error(err.message || err);
            })
            .finally(() => {
              this.meta.loading = false;
            });

        } catch (err) {
          if (err && err != "cancel") {
            console.log(err);
            this.$message.error(err.message || err);
          }
        }
      },
      inDetail(row) {
        this.selInfo = this.$utils.Obj.clone(row);
        this.meta.showDetail = true;
      },
      delNurse(row){
        this.$confirm("确定要删除该护理项目？", "警告", { type: "warning",})
        .then(() => {
          this.meta.loading = true;
          api.NursingItem.del(row.id).then((res) => {
              this.meta.loading = false;
              this.init()
            })
            .catch((err) => {
              this.meta.loading = false;
              this.$message.error(err);
            });
        })
        .catch((e) => {});
      },
      getFeeStandList(){
        api.FeeStandard.query({pageSize:1000}).then(res=>{
          this.feeList = res.items
        }).catch(err=>{
          console.log('Fee==',err)
        })
      }
    },
    mounted(){
      this.getFeeStandList()
    }
  };
</script>